(()=>{


  window.addEventListener('load', function() {
    const productForm = document.querySelector('form[action="/cart/add"]');

    productForm.classList.add('is-disabled');

    //cookieにenableCartbuttonがある場合は、アンケートをスキップ
    if(document.cookie.match(/enableCartbutton=1/)){
      productForm.classList.remove('is-disabled');
      return;
    }

    const enqute_button = document.createElement('button');
    enqute_button.setAttribute('type', 'button');
    enqute_button.classList.add('btn');
    enqute_button.classList.add('btn--primary');
    enqute_button.classList.add('btn--full');
    enqute_button.classList.add('enquate-btn');
    enqute_button.innerHTML = '頭皮・肌トラブルチェック';
    enqute_button.addEventListener('click', function() {
      console.log('Enquire button clicked');
      document.querySelector('.customEnqute').classList.add('is-active');
    });

    productForm.appendChild(enqute_button);

    document.querySelectorAll('.customEnquete_quizItem').forEach((el, index) => {
      if(index != 0){
        el.style.display = 'none';
      }
    });

    this.document.querySelectorAll('.customEnquete_ans').forEach((el) => {
      el.addEventListener('click', function() {
        const next = this.getAttribute('data-next');
        if(next == 'end'){
          handleEndEnqute(productForm);
          return;
        }
       // if(next == 'end-none'){
        //    document.querySelector('.customEnqute').classList.remove('is-active');
         //   return;
        //  }

        //noの結果を表示に変更

       if(next == 'end-none'){
  document.querySelector('.customEnquete_resultMessage').style.display = 'block';
  return;
}
        
        document.querySelectorAll('.customEnquete_quizItem').forEach((item)=>{
          item.style.display = 'none';
        })
        document.querySelector('.customEnquete_quizItem[data-quiz="'+next+'"]').style.display = 'block';

        // handleEndEnqute(productForm);
      });
    });

    document.querySelector('.customEnqute_close').addEventListener('click', function() {
      document.querySelector('.customEnqute').classList.remove('is-active');
    });
  });
//クローズ追加


  function handleEndEnqute(productForm) {
    console.log('Enqute ended');
    productForm.classList.remove('is-disabled');
    document.querySelector('.customEnqute').classList.remove('is-active');
    document.querySelector('.enquate-btn').remove();

    // cookieに保存
    document.cookie = 'enableCartbutton=1; max-age=86400; path=/';

  }
})();
